import React from "react";
import Box from "@mui/material/Box";
import PersonIcon from "@mui/icons-material/Person";

import * as appActions from "../../Actions/appActions";

import connectWithDispatch from "../../Hooks/connectWithDispatch";

interface BackCharactersProps {
  setScreenPopUp: (value: ScreenPopUpType | null) => void;
  disabled?: boolean;
}

function BackHome(props: BackCharactersProps) {
  const { setScreenPopUp, disabled = false } = props;

  const BackCharacters = () => (!disabled ? setScreenPopUp("backCharacters") : "");

  return (
    <Box sx={styles.container} onClick={BackCharacters}>
      <PersonIcon />
    </Box>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "0.5em",
    color: "white",
  },
};

const mapStateToProps = (state: StateType) => {
  return {};
};

const mapDispatchToProps: MapDispatchToProps = {
  setScreenPopUp: appActions.setScreenPopUp,
};

export default connectWithDispatch(BackHome, mapStateToProps, mapDispatchToProps);
